<template>
  <div class="block">
    <header>
      <div class="myBalance">
        <span class="title">我的余额</span>
        <span class="value">¥ {{ balance }}</span>
      </div>
      <div class="links">
        <span :underline="false" @click="checkRule">兑换规则 ></span>
        <span :underline="false" @click="jumpOrderList">查看订单 ></span>
      </div>
    </header>
    <div class="money-type">
      <div
        :class="[activeName === '1' ? 'active item' : 'item']"
        :key="1"
        @click="handleTabsChange({ name: '1' })"
      >
        全部<span v-if="allCount">({{ allCount }})</span>
      </div>
      <div
        :class="[activeName === '2' ? 'active item' : 'item']"
        :key="2"
        @click="handleTabsChange({ name: '2' })"
      >
        销量
      </div>
      <div
        :class="[activeName === '3' ? 'active item' : 'item']"
        :key="3"
        @click="handleTabsChange({ name: '3' })"
      >
        价格
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <div class="productionCont">
          <div
            class="productionCard"
            v-for="(item, index) in totalList"
            :key="index"
            @click="jumpDetail(item)"
          >
            <div class="imgWrap">
              <img :src="item.image" />
              <span>{{ item.sell_num }}人已兑换</span>
            </div>
            <h4>{{ item.name }}</h4>
            <div class="desc">{{ item.description }}</div>
            <div class="footer">
              <div class="money">{{ item.price }}</div>
              <div class="stock">
                库存{{
                  item.stock === 9999 ? item.stock : item.stock - item.sell_num
                }}
              </div>
            </div>
            <div
              v-if="item.month_buy"
              class="cornerMark"
              :class="{ disabled: item.buy_num == item.month_buy }"
            >
              每月限购{{ item.buy_num || 0 }}/{{ item.month_buy }}
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import mixins from '../../../mixins/exchangeShop/home.mixins';
export default {
  mixins: [mixins],
  methods: {
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  width: 710px;
  height: 188px;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px 25px 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .myBalance {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .title {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 33px;
      margin-bottom: 33px;
    }
    .value {
      height: 70px;
      font-size: 50px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 70px;
    }
  }
  .links {
    display: flex;
    justify-content: flex-end;
    span {
      margin-left: 36px;
      height: 37px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3b9aff;
      line-height: 37px;
    }
  }
}
.money-type {
  display: flex;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 32px;
  .name {
    color: #000000;
    font-size: 28px;
    margin-right: 11px;
  }
  .item {
    padding: 14px 16px;
    // padding: 14px 0;
    text-align: center;
    font-size: 24px;
    height: 60px;
    width: auto;
    background-color: #ffffff;
    border-radius: 4px;
    border-radius: 4px;
    margin-right: 14px;
    margin-left: 0;
  }
  .active.item {
    background: #fd9b21;
    color: #ffffffff;
  }
}
.productionCont {
  padding: 40px 37px 0;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  width: 750px;
  background: #fff;
  margin-top: 20px;
  margin-left: -20px;
  .productionCard {
    width: 313px;
    height: 485px;
    border: 1px solid #ffcc40;
    border-radius: 4px;
    position: relative;
    padding: 22px;
    margin-right: 50px;
    margin-bottom: 40px;
    cursor: pointer;
    &:nth-child(2n) {
      margin-right: 0;
    }
    .cornerMark {
      position: absolute;
      top: -1px;
      right: -1px;
      background: #3b9aff;
      border-radius: 0px 8px 0px 20px;
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 40px;
      width: 158px;
      height: 40px;
      text-align: center;
      &.disabled {
        background-color: #ccc;
      }
    }
    .imgWrap {
      width: 269px;
      height: 270px;
      background: #fef4de;
      position: relative;
      margin: auto;
      img {
        width: 270px;
        height: 270px;
      }
      span {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 259px;
        text-align: right;
        height: 20px;
        font-size: 20px;
        line-height: 20px;
        padding: 13px 5px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        background: rgba(0, 0, 0, 0.6);
        box-sizing: content-box;
      }
    }
    h4 {
      margin-top: 11px;
      height: 30px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #262626;
      line-height: 30px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .desc {
      height: 56px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #878d99;
      line-height: 28px;
      min-height: 56px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 4px;
    }
    .footer {
      margin-top: 13px;
      border-top: 1px solid #ebebeb;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-top: 4px;
      .money {
        height: 62px;
        font-size: 44px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff5533;
        line-height: 62px;
        padding-left: 25px;
        position: relative;
        &::before {
          display: block;
          width: 16px;
          height: 20px;
          line-height: 20px;
          overflow: visible;
          content: '¥';
          color: #ff5533;
          font-size: 20px;
          position: absolute;
          left: 0;
          bottom: 16px;
        }
      }
      .stock {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fd9b21;
        line-height: 28px;
        margin-bottom: 8px;
      }
    }
  }
}
</style>
